import { getCapacityFilters } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
export const useGetCapacityFilters = (userId: string) => {
  const { data, status, refetch } = useQuery(['capacity-filters', userId], () =>
    getCapacityFilters(userId)
  );

  return {
    storedFilters: data,
    storedFiltersStatus: status,
    fetchStoredFilters: refetch,
  };
};
